import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { prepareHeaders, buildError, API } from '../../api/apis';
import { ApiResponse, DescribeProgrammaticAccessResponse, UpdateProgrammaticAccessRequest, UpdateProgrammaticAccessResponse, } from '../../interfaces/interfaces';

// Define the RTK Query service for settings
export const tokensService = createApi({
  reducerPath: 'tokensApi',
  tagTypes: ['Tokens'],
  baseQuery: fetchBaseQuery({
    prepareHeaders: prepareHeaders,
  }),
  endpoints: (builder) => ({
    getTokens: builder.query({
      query: () => {
        const result = API.FETCH_TOKENS();
        return result || ''; // Ensure a valid string is returned
      },
      providesTags: ['Tokens'],
      transformResponse: (response: ApiResponse) => {
        return response.Response as DescribeProgrammaticAccessResponse;
      },
      transformErrorResponse: (response) => {
        return buildError(response, "");
      },
    }),
    updateTokensInfo: builder.mutation({
      query: (request: UpdateProgrammaticAccessRequest) => ({
        url: API.UPDATE_TOKENS(),
        method: 'PUT',
        body: request,
      }),
      invalidatesTags: ['Tokens'],
      transformResponse: (response: ApiResponse) => {
        return response.Response as UpdateProgrammaticAccessResponse;
      },
      transformErrorResponse: (response) => {
        return buildError(response, "");
      },
    }),
  }),
});

// Export hooks for usage in functional components
export const { useGetTokensQuery, useUpdateTokensInfoMutation } = tokensService;
